import { useState, useCallback } from "react";

export const useItemStack = () => {
  const [itemStack, setItemStack] = useState([]);

  let topItem = itemStack.length === 0 ? null : itemStack.at(-1);

  const addItem = useCallback(function addSubFlowItem(item) {
    setItemStack((itemStack) => {
      itemStack.push(item);
      return [...itemStack];
    });
  }, []);

  const removeItem = useCallback(function removeSubFlowItem() {
    setItemStack((itemStack) => {
      itemStack.pop();
      return [...itemStack];
    });
  }, []);

  const updateItemStack = (items) => {
    setItemStack(items);
  };

  return { topItem, addItem, removeItem, updateItemStack };
};
